export default __webpack_public_path__ + "0b5849146db6d395c423e4efca4d9e85.png";